import { connect } from 'react-redux';

import addAbilityToOpenModal from '../../utilities/modalHOC';
import { getPermissions } from '../Login/selectors';
import {
  createPromptAction,
  deletePromptAction,
  editPromptAction,
  getAllPromptsAction,
  loadPromptDetails,
  setCreateMode,
  setPromptDetailsAction,
  toggleActivePromptAction,
} from './actionSagas';
import Prompts from './Prompts';
import {
  getCreateModeSelector,
  getPromptDetailsSelectors,
  getPromptsSelectors,
  loadPromptDetailsSelectors,
  setLoadingInfoSelector,
} from './selectors';

const mapStateToProps = (state) => ({
  prompts: getPromptsSelectors(state),
  promptDetails: getPromptDetailsSelectors(state),
  loadPrompt: loadPromptDetailsSelectors(state),
  loadingInfo: setLoadingInfoSelector(state),
  createMode: getCreateModeSelector(state),
  permissions: getPermissions(state),
});

const mapDispatchToProps = (dispatch) => ({
  getAllPrompts: () => dispatch(getAllPromptsAction()),
  setPromptDetail: (promptId) => dispatch(setPromptDetailsAction(promptId)),
  loadPromptDetails: (value) => dispatch(loadPromptDetails(value)),
  createPrompt: (prompt) => dispatch(createPromptAction(prompt)),
  editPrompt: (prompt) => dispatch(editPromptAction(prompt)),
  deletePrompt: (prompt) => dispatch(deletePromptAction(prompt)),
  activePrompt: (promptId, value) =>
    dispatch(toggleActivePromptAction(promptId, value)),
  setCreateMode: (value) => dispatch(setCreateMode(value)),
});

const PromptsContainer = connect(mapStateToProps, mapDispatchToProps)(Prompts);

export default addAbilityToOpenModal(PromptsContainer);
